import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {RecordsTable} from '../tables/RecordsTable';
import {useProductsSelection} from '../hooks/useProductsSelection';

// FNP-918: the page reads SELECTION and passes it to both consumers — the table
// (which renders the checkboxes) and the header (which renders the batch delete
// button). They are siblings, so the shared parent threads it through.
//
// The state itself lives in the Redux products.selection slice (FNP-951), so
// both could read it directly; passing it down keeps RecordsTable driven by
// props and therefore testable without a store.
export const IndexPage = () => {
    const selection = useProductsSelection();

    return (
        <SimplePageLayout
            pageHeader={
                <IndexPageHeader
                    selectedIds={selection.selectedIds}
                    onDeleteComplete={selection.handleClearSelection}
                />
            }
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable selection={selection}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
